import { Typography, styled } from "@mui/material";
import { Link } from "react-router";

import { ForwardIcon } from "@citrine/atoms/icons";

export const ActivityLink = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  color: theme.palette.text.primary,
  display: "flex",
  flexDirection: "column",
  borderLeft: `solid ${theme.spacing(1)}`,
}));
export const Title = styled(Typography)(({ theme }) => ({
  display: "flex",
  paddingLeft: theme.spacing(1),
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  whiteSpace: "nowrap",

  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: theme.spacing(1),
}));

export const Icon = styled(ForwardIcon)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  color: theme.palette.text.secondary,
}));
